import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useTopicoComunicacao = () => {
  const [topicoComunicacao, setTopicoComunicacao] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchTopicoComunicacao = async () => {
      try {
        const response = await httpClient.get(
          `/api/fornecedorcomunicacao/topicocomunicacao`,
        );

        const options = response.data.map(
          (topicoComunicacao: { value: number; label: string }) => ({
            value: topicoComunicacao.value.toString(),
            label: topicoComunicacao.label,
          }),
        );
        setTopicoComunicacao(options);
      } catch (error) {
        console.error('Erro ao buscar Tópico Comunicacao', error);
      }
    };

    fetchTopicoComunicacao();
  }, []);

  return topicoComunicacao;
};
